/* eslint-disable react-hooks/rules-of-hooks */
import logo from "../../assets/images/logo.png";
import "./AppHeader.css";
import { hideCpf } from "utils/mask";
import { LOCAL_STORE_NOME_LOJA } from "../../constants";
import { useAppSelector } from "redux/app/hooks";

const AppHeader = () => {
  const {
    cliente: { cpf, nome, cartaoAtual },
  } = useAppSelector((state) => state.cliente);
  const { nomeLoja, pinPadAvailable } = useAppSelector(
    (state) => state.security
  );
  const nomeLojaStorge = localStorage.getItem(LOCAL_STORE_NOME_LOJA);
  const nameStore = nomeLoja || nomeLojaStorge;

  return (
    <div className="header-root">
      <div className="logo-container">
        <img src={logo} alt="teu card logo" />
        <p>
          <b>Versão:</b> {process.env.REACT_APP_VERSAO_APP}
        </p>
      </div>
      {/* <span style={{ color: "red" }}>width: {window?.innerWidth}</span>
      <span style={{ color: "red" }}>height: {window?.innerHeight}</span> */}
      <div className="cliente-login">
        {cartaoAtual && (
          <>
            <h3>{nome}</h3>
            <p>
              <b>CPF:</b> {hideCpf(cpf || "")}
            </p>
            {/* {email && (
              <p>
                <b>E-mail:</b> {hideEmailMask(email)}
              </p>
            )} */}
          </>
        )}

        {nameStore ? (
          <p>
            <b>Loja:</b> {nameStore}
          </p>
        ) : (
          <p>
            <span>{"LOJA NÃO IDENTIFICADA"}</span>
          </p>
        )}

        {pinPadAvailable && (
          <p>
            <span>{"PINPAD não conectada!"}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default AppHeader;
